import { Tag } from "@/components/shared/Tag";
import { formatDate } from "@/utils/dateUtils";

/**
 * The day a feedback was given, as both feedback tables show it, with
 * "Imported" under it when the platform team entered it from a call or a sheet.
 */
const FeedbackDateCell = ({ date, imported }) => (
  <div className="flex flex-col items-start gap-1">
    <span className="text-text-primary text-[12px]">{date ? formatDate(date) : "—"}</span>
    {imported && <Tag text="Imported" />}
  </div>
);

export default FeedbackDateCell;
